export const AdvisorRuntimeIDBGroup = 'advisor-runtime';
//# sourceMappingURL=consts.js.map